<template>
  <AnimatedBackground>
    <ProjectsSection />
  </AnimatedBackground>
</template>

<script>
import ProjectsSection from '../components/ProjectsSection.vue';
import AnimatedBackground from '../components/AnimatedBackground.vue';

export default {
  name: 'ProjectsPage',
  components: {
    ProjectsSection,
    AnimatedBackground
  }
}
</script>

<style scoped>
.projects-page {
  min-height: 100vh;
  width: 100%;
  padding: 4rem 0;
  display: flex;
  flex-direction: column;
}
</style>
